import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllGlobalAnnouncementsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllGlobalAnnouncementsQuery = { __typename?: 'Query', allGlobalAnnouncements: Array<{ __typename: 'GlobalAnnouncement', id: string, name: string, content: string, roles: Array<string>, activated: boolean, emailNotification: boolean, createdAt?: any | null, startDate?: any | null, endDate?: any | null, createdBy: { __typename?: 'User', id: string, name: string }, modifiedBy: { __typename?: 'User', id: string, name: string } }> };

export type CreateGlobalAnnouncementMutationVariables = Types.Exact<{
  input: Types.CreateGlobalAnnouncementInput;
}>;


export type CreateGlobalAnnouncementMutation = { __typename?: 'Mutation', createGlobalAnnouncement: { __typename?: 'GlobalAnnouncementPayload', globalAnnouncement: { __typename?: 'GlobalAnnouncement', id: string } } };

export type UpdateGlobalAnnouncementMutationVariables = Types.Exact<{
  input: Types.UpdateGlobalAnnouncementInput;
}>;


export type UpdateGlobalAnnouncementMutation = { __typename?: 'Mutation', updateGlobalAnnouncement: { __typename?: 'GlobalAnnouncementPayload', globalAnnouncement: { __typename?: 'GlobalAnnouncement', id: string } } };

export type DeleteGlobalAnnouncementMutationVariables = Types.Exact<{
  input: Types.DeleteGlobalAnnouncementInput;
}>;


export type DeleteGlobalAnnouncementMutation = { __typename?: 'Mutation', deleteGlobalAnnouncement: { __typename?: 'DeleteGlobalAnnouncementPayload', globalAnnouncement?: { __typename?: 'GlobalAnnouncement', id: string } | null } };


export const GetAllGlobalAnnouncementsDocument = gql`
    query GetAllGlobalAnnouncements {
  allGlobalAnnouncements {
    id
    name
    content
    roles
    activated
    emailNotification
    createdBy {
      id
      name
    }
    modifiedBy {
      id
      name
    }
    createdAt
    startDate
    endDate
    __typename
  }
}
    `;

/**
 * __useGetAllGlobalAnnouncementsQuery__
 *
 * To run a query within a React component, call `useGetAllGlobalAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllGlobalAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllGlobalAnnouncementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllGlobalAnnouncementsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllGlobalAnnouncementsQuery, GetAllGlobalAnnouncementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllGlobalAnnouncementsQuery, GetAllGlobalAnnouncementsQueryVariables>(GetAllGlobalAnnouncementsDocument, options);
      }
export function useGetAllGlobalAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllGlobalAnnouncementsQuery, GetAllGlobalAnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllGlobalAnnouncementsQuery, GetAllGlobalAnnouncementsQueryVariables>(GetAllGlobalAnnouncementsDocument, options);
        }
export type GetAllGlobalAnnouncementsQueryHookResult = ReturnType<typeof useGetAllGlobalAnnouncementsQuery>;
export type GetAllGlobalAnnouncementsLazyQueryHookResult = ReturnType<typeof useGetAllGlobalAnnouncementsLazyQuery>;
export type GetAllGlobalAnnouncementsQueryResult = Apollo.QueryResult<GetAllGlobalAnnouncementsQuery, GetAllGlobalAnnouncementsQueryVariables>;
export const CreateGlobalAnnouncementDocument = gql`
    mutation CreateGlobalAnnouncement($input: CreateGlobalAnnouncementInput!) {
  createGlobalAnnouncement(input: $input) {
    globalAnnouncement {
      id
    }
  }
}
    `;
export type CreateGlobalAnnouncementMutationFn = Apollo.MutationFunction<CreateGlobalAnnouncementMutation, CreateGlobalAnnouncementMutationVariables>;

/**
 * __useCreateGlobalAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateGlobalAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlobalAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlobalAnnouncementMutation, { data, loading, error }] = useCreateGlobalAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGlobalAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<CreateGlobalAnnouncementMutation, CreateGlobalAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGlobalAnnouncementMutation, CreateGlobalAnnouncementMutationVariables>(CreateGlobalAnnouncementDocument, options);
      }
export type CreateGlobalAnnouncementMutationHookResult = ReturnType<typeof useCreateGlobalAnnouncementMutation>;
export type CreateGlobalAnnouncementMutationResult = Apollo.MutationResult<CreateGlobalAnnouncementMutation>;
export type CreateGlobalAnnouncementMutationOptions = Apollo.BaseMutationOptions<CreateGlobalAnnouncementMutation, CreateGlobalAnnouncementMutationVariables>;
export const UpdateGlobalAnnouncementDocument = gql`
    mutation UpdateGlobalAnnouncement($input: UpdateGlobalAnnouncementInput!) {
  updateGlobalAnnouncement(input: $input) {
    globalAnnouncement {
      id
    }
  }
}
    `;
export type UpdateGlobalAnnouncementMutationFn = Apollo.MutationFunction<UpdateGlobalAnnouncementMutation, UpdateGlobalAnnouncementMutationVariables>;

/**
 * __useUpdateGlobalAnnouncementMutation__
 *
 * To run a mutation, you first call `useUpdateGlobalAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlobalAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlobalAnnouncementMutation, { data, loading, error }] = useUpdateGlobalAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGlobalAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGlobalAnnouncementMutation, UpdateGlobalAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGlobalAnnouncementMutation, UpdateGlobalAnnouncementMutationVariables>(UpdateGlobalAnnouncementDocument, options);
      }
export type UpdateGlobalAnnouncementMutationHookResult = ReturnType<typeof useUpdateGlobalAnnouncementMutation>;
export type UpdateGlobalAnnouncementMutationResult = Apollo.MutationResult<UpdateGlobalAnnouncementMutation>;
export type UpdateGlobalAnnouncementMutationOptions = Apollo.BaseMutationOptions<UpdateGlobalAnnouncementMutation, UpdateGlobalAnnouncementMutationVariables>;
export const DeleteGlobalAnnouncementDocument = gql`
    mutation DeleteGlobalAnnouncement($input: DeleteGlobalAnnouncementInput!) {
  deleteGlobalAnnouncement(input: $input) {
    globalAnnouncement {
      id
    }
  }
}
    `;
export type DeleteGlobalAnnouncementMutationFn = Apollo.MutationFunction<DeleteGlobalAnnouncementMutation, DeleteGlobalAnnouncementMutationVariables>;

/**
 * __useDeleteGlobalAnnouncementMutation__
 *
 * To run a mutation, you first call `useDeleteGlobalAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlobalAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlobalAnnouncementMutation, { data, loading, error }] = useDeleteGlobalAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteGlobalAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGlobalAnnouncementMutation, DeleteGlobalAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGlobalAnnouncementMutation, DeleteGlobalAnnouncementMutationVariables>(DeleteGlobalAnnouncementDocument, options);
      }
export type DeleteGlobalAnnouncementMutationHookResult = ReturnType<typeof useDeleteGlobalAnnouncementMutation>;
export type DeleteGlobalAnnouncementMutationResult = Apollo.MutationResult<DeleteGlobalAnnouncementMutation>;
export type DeleteGlobalAnnouncementMutationOptions = Apollo.BaseMutationOptions<DeleteGlobalAnnouncementMutation, DeleteGlobalAnnouncementMutationVariables>;